module.exports = __webpack_public_path__ + "img/mapicon.750f4db0.svg";